module.exports = __webpack_public_path__ + "img/mypage_banner_03.033f406d.png";